import React from "react";
import { MODEL_SEARCH_PLACEHOLDER } from "../Commend3Constants";

type ModelSearchProps = {
  value: string;
  onChange: (next: string) => void;
};

const SearchIcon = () => (
  <svg
    viewBox="0 0 24 24"
    className="tw-pointer-events-none tw-absolute tw-right-[14px] tw-top-1/2 tw-h-5 tw-w-5 -tw-translate-y-1/2"
    style={{ stroke: "#9C9C9C", fill: "none", strokeWidth: 1.6, strokeLinecap: "round" }}
    aria-hidden="true"
  >
    <circle cx="11" cy="11" r="7.5" />
    <path d="M17 17.5l3 3" />
  </svg>
);

const ModelSearch = ({ value, onChange }: ModelSearchProps) => (
  <div id="commend3-model-search" className="tw-relative tw-w-[340px] tw-max-w-[58%]">
    <input
      id="commend3-model-search-input"
      type="text"
      placeholder={MODEL_SEARCH_PLACEHOLDER}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className="tw-h-[44px] tw-w-full tw-rounded-lg tw-border tw-border-[#E3E5EC] tw-bg-white tw-pl-[14px] tw-pr-[44px] tw-text-[15px] tw-text-[#0B0C23]"
      aria-label={MODEL_SEARCH_PLACEHOLDER}
    />
    <SearchIcon />
  </div>
);

export default ModelSearch;
